import { getSentraIntegrationService } from 'common/module_interface/RiskManagement/Services';

export async function addOrUpdateSentraAccount(apiKey: string, name: string, accountId?: string) {
    if (accountId) {
        return await getSentraIntegrationService().updateSentraAccount(accountId, apiKey, name);
    } else {
        return await getSentraIntegrationService().addSentraAccount(apiKey, name);
    }
}
